import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';

@Injectable({
  providedIn: 'root',
})
export class GoalsService {
  constructor(private restangular: Restangular) {}

  getGoalById(goalId: string): Promise<any> {
    return this.restangular.one('goals', goalId).get().toPromise();
  }
}
